'use client'

import { Chip } from '@heroui/react'
import { titleCase } from '../lib/view'

export type ChipTone = 'default' | 'accent' | 'success' | 'warning' | 'danger'

interface StatusChipProps {
  status?: string
  tone: ChipTone
  label?: string
  size?: 'sm' | 'md'
  variant?: 'soft' | 'primary' | 'secondary' | 'tertiary'
}

export function StatusChip({ status, tone, label, size = 'sm', variant = 'soft' }: StatusChipProps): React.ReactElement {
  return (
    <Chip color={tone} size={size} variant={variant}>
      {label ?? titleCase(status)}
    </Chip>
  )
}
